import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Gallery from "@/components/Gallery";
import FlagFeature from "@/components/FlagFeature";
import VideoGiri from "@/components/VideoGiri";
import DiventaSocio from "@/components/DiventaSocio";
import Events from "@/components/Events";
import PastRides from "@/components/PastRides";
import Direttivo from "@/components/Direttivo";
import MerchShop from "@/components/MerchShop";
import ClubShop from "@/components/ClubShop";
import Contacts from "@/components/Contacts";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import CheckoutModal from "@/components/CheckoutModal";
import MusicPlayer from "@/components/MusicPlayer";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <FlagFeature />
        <Gallery />
        <VideoGiri />
        <Events />
        <PastRides />
        <Direttivo />
        <MerchShop />
        <ClubShop />
        <DiventaSocio />
        <Contacts />
      </main>
      <Footer />
      <CartDrawer />
      <CheckoutModal />
      <MusicPlayer />
    </div>
  );
}
